module.exports = __webpack_public_path__ + "img/blackCursorIcon.020e5d14.svg";